import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=6f781a91"
import script from "./EmailConfirmation.js?vue&type=script&lang=js&external"
export * from "./EmailConfirmation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports